export default {
    props: ["form", "representative", "editing", "isProspect"],

    data () {
        return (!this.isProspect) ? {
            edition: {
                info: false,
                address: false
            }
        } : {}
    },

    mounted () {
        $('.terminate', this.$el)
            .datepicker({
                format: 'yyyy-mm-dd'
            })
            .on('changeDate', (event) => {
                $('.terminate', this.$el).datepicker('hide')
                this.askForTermination(event.format())
            })

        if (!this.isProspect)
            this.$watch(
                'editing',
                function (now, before) {
                    if (!now && before) {
                        this.edition.info = false
                        this.edition.address = false
                    }
                }
            )
    },

    methods: {
        askForEdition () {
            this.$emit('edit', this.representative.representative_id)
        },

        askForInfoEdition () {
            this.$emit('edit-info', this.representative.representative_id)
            this.edition.info = true
        },

        askForAddressEdition () {
            this.$emit('edit-address', this.representative.representative_id)
            this.edition.address = true
        },

        askForTermination (representative_end_date) {
            this.$emit(
                'terminate',
                {
                    representative_id: this.representative.representative_id,
                    representative_end_date
                }
            )
        },

        askForDeletion () {
            this.$emit('remove', this.representative.representative_id)
        },

        updateData () {
            this.$emit('update')
        },

        handleRepresentativeEdition ($event, type = null) {
            this.$emit('finish-edit', $event, type)
        },
    },


    computed: {
        decodedRepresentative () {
            return this.representative && this.representative.hasOwnProperty('person') && {
                    ...this.decodeRepresentative(this.representative.person),
                    ...this.representative.address
                }
        },

        isTerminated () {
            return this.decodedRepresentative && this.decodedRepresentative.hasOwnProperty('representative_end_date')
                && this.decodedRepresentative.representative_end_date
        }
    },
}



// WEBPACK FOOTER //
// ./client/mixins/representative.js